/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import $ from 'jquery';
import { isAcceptedLiveWidget } from './ExtVisUtil';
import { showUnsupportedExtVisToast } from './ToastUtil';

class DnDHandler {
	constructor(options) {
		this.domNode = options.domNode;
		this.className = options.className;
		this.dashboardApi = options.dashboardApi;
		this.activate = options.activate;
		this.deactivate = options.deactivate;
		this.isExtVis = false;
	}

	accepts() {
		return false;
	}

	activateDropTarget() {
		this.activate && this.activate();
		$(this.domNode).toggleClass(this.className, true);
	}

	deactivateDropTarget() {
		this.deactivate && this.deactivate();
		$(this.domNode).toggleClass(this.className, false);
	}

	onDragEnter(dragObject) {
		this.activateDropTarget();
		if (dragObject.avatar && dragObject.avatar.length && dragObject.avatar.length > 0) {
			dragObject.avatar[0].style.zIndex = '9999999';
		}
	}

	onDragLeave() {
		this.deactivateDropTarget();
	}

	onDragEnd() {
		this.deactivateDropTarget();
		if (this.isExtVis && this.glassContext) {
			showUnsupportedExtVisToast(this.glassContext);
			this.isExtVis = false;
		}
	}

	onDrop(dragObject, dropNode) {
		this.dropHandler(dragObject, dropNode);
	}

	getSpecfromPin(dragObject) {
		const content = dragObject.data.pinSpec.content;
		return this.dashboardApi.getGlassSvc('.ConversionService')
			.then(conversionSvc => conversionSvc.convert('DASHBOARD', 'EXPLORE', JSON.stringify(content)))
			.then(spec => JSON.parse(spec));
	}

	isPinObject(dragObject) {
		return dragObject.type === 'pin';
	}

	isAcceptedLiveWidget(dragObject) {
		const result = isAcceptedLiveWidget(dragObject, true /* markCustomVisWidget */);
		if (!result && dragObject.isExtVis) {
			this.isExtVis = dragObject.isExtVis;
		}
		return result;
	}

	getPinWidgets(dragObject) {
		if (dragObject.data.pinSpec.content.widgets) {
			const liveWidgets = dragObject.data.pinSpec.content.widgets.filter(widget => this.isAcceptedLiveWidget(widget));
			return liveWidgets;
		}
		return [];
	}
}

export default DnDHandler;



// WEBPACK FOOTER //
// ./src/js/util/DnDHandler.js